// @flow
import * as React from 'react';
import { connect } from 'react-redux';

type Props = {
  condition?: boolean,
  eventTracking: EventTracking,
  children: ?Function,
};

type OwnProps = {
  event: Function,
};

type MapStateToProps = {
  eventTracking: EventTracking,
};

export class InnerComponent extends React.Component<Props> {
  static defaultProps = {
    condition: true,
  };

  componentDidMount() {
    const { children, condition } = this.props;

    if (!children && (condition === undefined || condition === true)) {
      this.handleEventTrackingSend();
    }
  }

  handleEventTrackingSend = () => {
    this.props.eventTracking.send();
  };

  render() {
    const { children } = this.props;

    if (typeof children === 'function') {
      return children(this.handleEventTrackingSend);
    }

    return null;
  }
}

export function mapStateToProps(state: Object, ownProps: OwnProps): MapStateToProps {
  return {
    eventTracking: ownProps.event(state, ownProps),
  };
}
const EventTrackingContainer = connect(mapStateToProps)(InnerComponent);

EventTrackingContainer.displayName = 'EventTrackingContainer';

export default EventTrackingContainer;



// WEBPACK FOOTER //
// ./app/tracking/components/EventTracking/container.js